import React from 'react';

import Reach from '../../common/Reach';
import Feedback from '../../common/Feedback';
import TrainerReflectionFeedback from '../../common/TrainerReflectionFeedback';

import BehavioralInsight from '../../common/BehavioralInsight';

const content = {
  cont1:
    'This section provides an overview of sessions and related surveys collected via the app. I you wish to export the results click on "Export as CSV" and it will export and do',
  cont2:
    'This section shows a break down of answers given by your course participants stemming from surveys responses (categories: about your way of teaching (train the trainer) and about your trainer(other session types). The numbers show the count of each answerrelated to a particular survey type).',
  cont4:
    'This section lets you filter and export the post-session feedback trainers submit about delivering their own modules.',
  cont3:
    'We all know that changing what we do is not as simple as knowing what to do. Just because we CAN do something doesn’t mean that we WILL do it. We will be asking you some questions about what you do in practice, about what you expect you will do when you return to work and about some of the thoughts and feelings you have that make up your capability, opportunity and motivation. This will help you and us understand about experiences of doing the behaviours promoted in Gwent Connect 5 as you go about your work.'
};

export default {
  reach: {
    text: 'Reach',
    infoContent: content.cont1,
    render: ({
      results,
      handleFilteredData,
      defaultFilters,
      hiddenFields,
      resultForRole
    }) => (
      <Reach
        data={results}
        role={resultForRole}
        handleFilteredData={handleFilteredData}
        defaultFilters={defaultFilters}
        hiddenFields={hiddenFields}
      />
    )
  },
  feedback: {
    text: 'Participant Feedback',
    infoContent: content.cont2,
    render: ({ resultForRole, filters, hiddenFields }) => (
      <Feedback
        role={resultForRole}
        showFilters
        defaultFilters={filters}
        hiddenFields={hiddenFields}
      />
    )
  },

  trainerReflection: {
    text: 'Trainer feedback',
    infoContent: content.cont4,
    render: ({ resultForRole, filters, hiddenFields = [] }) => (
      <TrainerReflectionFeedback
        role={resultForRole}
        defaultFilters={filters}
        hiddenFields={[...hiddenFields, 'localAuthority']}
      />
    )
  },

  behavior: {
    text: 'Behavioural',
    infoContent: content.cont3,
    render: ({
      resultsFor,
      resultForRole,
      filters,
      hiddenFields,
      ...props
    }) => {
      return (
        <BehavioralInsight
          {...props}
          trainerId={resultsFor}
          role={resultForRole}
          defaultFilters={filters}
          hiddenFields={hiddenFields}
          showFilters
        />
      );
    }
  }
};
